import { useState } from "react";
import { sablonlarData, MesajSablon } from "@/mocks/takip";

const KATEGORI_COLOR: Record<string, string> = {
  "Referans": "bg-violet-100 text-violet-700",
  "Ödeme": "bg-amber-100 text-amber-700",
  "Taahhüt": "bg-orange-100 text-orange-700",
  "Kampanya": "bg-sky-100 text-sky-700",
  "Sistem": "bg-gray-100 text-gray-600",
  "Yeni Kayıt": "bg-emerald-100 text-emerald-700",
  "Deneme": "bg-pink-100 text-pink-700",
  "Bilgilendirme": "bg-blue-100 text-blue-700",
};

const DEGISKENLER = [
  "%veli_adi", "%ogrenci_adi", "%telefon", "%odeme_tarihi",
  "%taahhut_bitis_tarihi", "%kampanya_adi", "%son_tarih", "%duraklatma_formu",
];

interface EditorModalProps {
  sablon: MesajSablon | null;
  onClose: () => void;
}
function EditorModal({ sablon, onClose }: EditorModalProps) {
  const isNew = sablon === null;
  const [ad, setAd] = useState(sablon?.baslik ?? "");
  const [kategori, setKategori] = useState(sablon?.kategori ?? "Referans");
  const [icerik, setIcerik] = useState(sablon?.icerik ?? "");
  const [saved, setSaved] = useState(false);

  const preview = icerik
    .replace(/%veli_adi/g, "Ayşe Hanım")
    .replace(/%ogrenci_adi/g, "Zeynep")
    .replace(/%telefon/g, "0532 111 22 33")
    .replace(/%odeme_tarihi/g, "25 Mayıs 2026")
    .replace(/%taahhut_bitis_tarihi/g, "01 Haziran 2026")
    .replace(/%kampanya_adi/g, "Mayıs Kampanyası")
    .replace(/%son_tarih/g, "31 Mayıs 2026")
    .replace(/%duraklatma_formu/g, "forms.gostudent.com/dur");

  const insertVar = (v: string) => setIcerik(prev => prev + v);

  return (
    <div className="fixed inset-0 z-50 flex items-start justify-center p-4 overflow-y-auto">
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={() => !saved && onClose()} />
      <div className="relative bg-white rounded-2xl w-full max-w-4xl shadow-2xl my-6">
        <div className="bg-[#0B1120] px-6 py-4 rounded-t-2xl flex items-center justify-between">
          <h3 className="text-white font-bold text-sm">
            {isNew ? "Yeni Mesaj Şablonu" : `Şablonu Düzenle – ${sablon?.baslik}`}
          </h3>
          <button onClick={onClose} className="w-7 h-7 flex items-center justify-center rounded-lg hover:bg-white/10 text-gray-400 cursor-pointer">
            <i className="ri-close-line"></i>
          </button>
        </div>

        {saved ? (
          <div className="p-12 text-center">
            <div className="w-14 h-14 rounded-full bg-emerald-100 flex items-center justify-center mx-auto mb-3">
              <i className="ri-checkbox-circle-line text-emerald-600 text-2xl"></i>
            </div>
            <p className="font-semibold text-gray-800">Şablon kaydedildi!</p>
          </div>
        ) : (
          <div className="p-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-5">
              <div>
                <label className="block text-xs font-semibold text-gray-600 mb-1.5">Şablon Adı</label>
                <input
                  value={ad}
                  onChange={e => setAd(e.target.value)}
                  placeholder="Şablon adı yazın..."
                  className="w-full px-4 py-2.5 text-sm border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#25D366]/30 focus:border-[#25D366]"
                />
              </div>
              <div>
                <label className="block text-xs font-semibold text-gray-600 mb-1.5">Kategori</label>
                <div className="relative">
                  <select
                    value={kategori}
                    onChange={e => setKategori(e.target.value)}
                    className="w-full px-4 py-2.5 text-sm border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#25D366]/30 focus:border-[#25D366] appearance-none bg-white cursor-pointer"
                  >
                    {Object.keys(KATEGORI_COLOR).map(k => <option key={k}>{k}</option>)}
                  </select>
                  <div className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none text-gray-400">
                    <i className="ri-arrow-down-s-line"></i>
                  </div>
                </div>
              </div>
            </div>

            {/* Değişkenler */}
            <div className="mb-3">
              <p className="text-xs font-semibold text-gray-600 mb-2">Değişken Ekle</p>
              <div className="flex flex-wrap gap-2">
                {DEGISKENLER.map(v => (
                  <button
                    key={v}
                    onClick={() => insertVar(v)}
                    className="px-2.5 py-1 text-[11px] font-mono bg-[#0B1120] text-[#25D366] rounded-lg cursor-pointer hover:bg-[#1a2a4a] transition-colors whitespace-nowrap"
                  >
                    {v}
                  </button>
                ))}
              </div>
            </div>

            {/* Split: editor + preview */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
              {/* Editor */}
              <div>
                <label className="block text-xs font-semibold text-gray-600 mb-1.5">Mesaj İçeriği</label>
                <textarea
                  value={icerik}
                  onChange={e => setIcerik(e.target.value)}
                  rows={10}
                  className="w-full px-4 py-3 text-sm border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#25D366]/30 focus:border-[#25D366] resize-none font-mono leading-relaxed"
                  placeholder="Mesaj içeriğini yazın..."
                />
                <div className="flex items-center justify-between mt-1.5 text-[11px] text-gray-400">
                  <span>{icerik.length} karakter</span>
                  <span>{icerik.split("\n").length} satır</span>
                </div>
              </div>

              {/* WhatsApp Preview */}
              <div>
                <label className="block text-xs font-semibold text-gray-600 mb-1.5">WhatsApp Önizleme</label>
                <div className="bg-[#ECE5DD] rounded-2xl overflow-hidden border border-gray-200">
                  {/* Phone header */}
                  <div className="bg-[#075E54] px-4 py-3 flex items-center gap-3">
                    <div className="w-8 h-8 rounded-full bg-[#25D366] flex items-center justify-center text-white text-xs font-bold flex-shrink-0">
                      {ad.charAt(0) || "G"}
                    </div>
                    <div>
                      <p className="text-white text-xs font-semibold">GoStudent Danışmanı</p>
                      <p className="text-[#B2DFDB] text-[10px]">çevrimiçi</p>
                    </div>
                  </div>
                  {/* Message bubble */}
                  <div className="p-4 min-h-[200px] flex items-start">
                    <div className="bg-white rounded-[12px] rounded-tl-none px-3 py-2 max-w-[90%] shadow-sm">
                      <p className="text-[12px] text-gray-800 leading-relaxed whitespace-pre-wrap">
                        {preview || <span className="text-gray-400 italic">Mesaj önizlemesi burada görünecek...</span>}
                      </p>
                      <p className="text-[10px] text-gray-400 text-right mt-1">14:32 ✓✓</p>
                    </div>
                  </div>
                </div>
                <p className="text-[11px] text-gray-400 mt-2">Değişkenler örnek verilerle gösterilmektedir.</p>
              </div>
            </div>

            <div className="flex gap-3 mt-5 pt-4 border-t border-gray-100">
              <button onClick={onClose} className="flex-1 py-2.5 text-sm border border-gray-200 text-gray-600 rounded-xl hover:bg-gray-50 cursor-pointer">İptal</button>
              <button
                onClick={() => { setSaved(true); setTimeout(() => { setSaved(false); onClose(); }, 1800); }}
                className="flex-1 py-2.5 text-sm bg-[#0B1120] text-white rounded-xl hover:bg-[#1a2a4a] cursor-pointer font-semibold"
              >
                Şablonu Kaydet
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default function SablonlarPage() {
  const [search, setSearch] = useState("");
  const [activeKategori, setActiveKategori] = useState("Tümü");
  const [editorModal, setEditorModal] = useState<MesajSablon | null | undefined>(undefined);

  const kategoriler = ["Tümü", ...Array.from(new Set(sablonlarData.map(s => s.kategori)))];

  const filtered = sablonlarData.filter(s => {
    const matchSearch = !search || s.baslik.toLowerCase().includes(search.toLowerCase()) || s.kategori.toLowerCase().includes(search.toLowerCase());
    const matchKategori = activeKategori === "Tümü" || s.kategori === activeKategori;
    return matchSearch && matchKategori;
  });

  return (
    <div className="p-4 md:p-6 xl:p-8 space-y-6 max-w-[1600px]">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
        <div>
          <h2 className="text-xl font-bold text-gray-900">Mesaj Şablonları</h2>
          <p className="text-sm text-gray-500 mt-0.5">Tekrar kullanılabilir WhatsApp mesaj şablonlarınızı yönetin</p>
        </div>
        <button
          onClick={() => setEditorModal(null)}
          className="px-5 py-2.5 text-sm bg-[#0B1120] text-white rounded-xl hover:bg-[#1a2a4a] cursor-pointer whitespace-nowrap flex items-center gap-2 font-semibold transition-colors"
        >
          <div className="w-4 h-4 flex items-center justify-center"><i className="ri-add-line text-sm"></i></div>
          Yeni Şablon Oluştur
        </button>
      </div>

      {/* Filters */}
      <div className="flex flex-col sm:flex-row gap-3">
        <div className="flex flex-wrap gap-2 flex-1">
          {kategoriler.map(k => (
            <button
              key={k}
              onClick={() => setActiveKategori(k)}
              className={`px-3 py-1.5 rounded-lg text-xs font-semibold cursor-pointer whitespace-nowrap transition-colors
                ${activeKategori === k ? "bg-[#0B1120] text-white" : "bg-white border border-gray-200 text-gray-600 hover:bg-gray-50"}`}
            >
              {k}
            </button>
          ))}
        </div>
        <div className="relative w-full sm:w-64">
          <div className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 flex items-center justify-center text-gray-400">
            <i className="ri-search-line text-sm"></i>
          </div>
          <input
            type="text"
            placeholder="Şablon ara..."
            value={search}
            onChange={e => setSearch(e.target.value)}
            className="w-full pl-9 pr-4 py-2 text-sm border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#25D366]/30 focus:border-[#25D366] bg-white"
          />
        </div>
      </div>

      {/* Template Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4">
        {filtered.map(s => (
          <div key={s.id} className="bg-white rounded-2xl border border-gray-100 flex flex-col hover:border-gray-200 transition-all group">
            <div className="p-5 flex-1">
              <div className="flex items-start justify-between gap-2 mb-3">
                <div className="flex-1 min-w-0">
                  <h3 className="text-sm font-bold text-gray-900 leading-snug">{s.baslik}</h3>
                  <div className="flex items-center gap-2 mt-1.5">
                    <span className={`px-2 py-0.5 rounded-full text-[10px] font-semibold ${KATEGORI_COLOR[s.kategori] || "bg-gray-100 text-gray-600"}`}>
                      {s.kategori}
                    </span>
                    <span className="text-[11px] text-gray-400">{s.kullanimSayisi}x kullanıldı</span>
                  </div>
                </div>
                <div className="w-9 h-9 rounded-xl bg-[#ECE5DD] flex items-center justify-center flex-shrink-0">
                  <i className="ri-whatsapp-line text-[#25D366] text-base"></i>
                </div>
              </div>
              <p className="text-xs text-gray-500 leading-relaxed line-clamp-3">{s.onizleme}</p>
            </div>
            <div className="px-5 pb-4 flex items-center justify-between border-t border-gray-100 pt-3">
              <span className="text-[11px] text-gray-400">Güncellendi: {s.guncellemeTarihi}</span>
              <div className="flex items-center gap-2">
                <button
                  onClick={() => setEditorModal(s)}
                  className="px-3 py-1.5 text-[11px] font-semibold border border-gray-200 text-gray-600 rounded-lg hover:bg-gray-50 cursor-pointer whitespace-nowrap transition-colors flex items-center gap-1"
                >
                  <i className="ri-edit-line text-xs"></i> Düzenle
                </button>
                <button
                  className="px-3 py-1.5 text-[11px] font-semibold bg-[#25D366] text-white rounded-lg hover:bg-[#20bd5a] cursor-pointer whitespace-nowrap transition-colors flex items-center gap-1"
                >
                  <i className="ri-check-line text-xs"></i> Kullan
                </button>
              </div>
            </div>
          </div>
        ))}
        {filtered.length === 0 && (
          <div className="col-span-full py-16 text-center">
            <div className="w-12 h-12 mx-auto rounded-full bg-gray-100 flex items-center justify-center mb-3">
              <i className="ri-file-text-line text-gray-400 text-xl"></i>
            </div>
            <p className="text-sm text-gray-400">Bu kategoride şablon bulunamadı</p>
            <button
              onClick={() => setEditorModal(null)}
              className="mt-3 px-4 py-2 text-sm bg-[#0B1120] text-white rounded-xl cursor-pointer hover:bg-[#1a2a4a]"
            >
              Yeni Şablon Oluştur
            </button>
          </div>
        )}
      </div>

      {editorModal !== undefined && (
        <EditorModal sablon={editorModal} onClose={() => setEditorModal(undefined)} />
      )}
    </div>
  );
}